import React from "react";
import "./index.css";
import Board from "./components/Board/Board";
import Sidebar from "./components/Sidebar/Sidebar";
import AuthPortal from "./components/AuthPortal/AuthPortal";
import { useAppSelector } from "./store/hooks/hooks";
import { selectCurrentUser } from "./store/user/user";

function App() {
  const currentUser = useAppSelector(selectCurrentUser);

  if (!currentUser) {
    return <AuthPortal />;
  }

  return (
    <div className="app-container">
      <Sidebar />
      <main className="game-zone">
        <Board />
      </main>
    </div>
  );
}

export default App;
